const API_URL = process.env.REACT_APP_API_URL;

function extractErrorMessage(errorBody, fallback) {
  if (!errorBody) return fallback;
  const detail = errorBody.detail;
  const title = errorBody.title;
  if (detail && title && title !== fallback) {
    return `${title}: ${detail}`;
  }
  return detail || fallback;
}

async function asJsonOrThrow(response, fallback) {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(extractErrorMessage(error, fallback));
  }
  return await response.json();
}

/**
 * Client for Settings → API keys: the per-environment credentials Zapier, Make, n8n or a
 * merchant's own code use against /api/hooks and /api/v1 instead of a browser's JWT session.
 */
class ApiKeysService {
  /** [{ id, label, keyPrefix, createdAt, lastUsedAt, revoked }] */
  async list(envId, authenticatedFetch) {
    const response = await authenticatedFetch(`${API_URL}/api/environments/${envId}/api-keys`);
    return asJsonOrThrow(response, 'Failed to load API keys');
  }

  /** { apiKey: {...}, key: 'fgk_live_...' }, key is shown only on this response. */
  async create(envId, label, authenticatedFetch) {
    const response = await authenticatedFetch(`${API_URL}/api/environments/${envId}/api-keys`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ label }),
    });
    return asJsonOrThrow(response, 'Failed to create API key');
  }

  async revoke(envId, keyId, authenticatedFetch) {
    const response = await authenticatedFetch(
      `${API_URL}/api/environments/${envId}/api-keys/${keyId}`,
      { method: 'DELETE' }
    );
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(extractErrorMessage(error, 'Failed to revoke API key'));
    }
  }
}

const apiKeysService = new ApiKeysService();
export default apiKeysService;
